module.exports = {
    getCurrentVendorID: function (user, url) {
        if (user && url) {
            let currentVendor = user.vendor && user.vendor.data ? user.vendor.data : null

            if (currentVendor) {
                // check if an admin user of a vendor is trying to see a children vendor
                if (user.vendor.data.admins && user.vendor.data.admins.includes(user.email) && user.vendor.data.childrens && user.vendor.data.childrens.length) {
                    let cvendor = user.vendor.data.childrens.filter((vendor) => {
                        return url.includes(vendor.slug)
                    })
                    if (cvendor.length) return cvendor[0].id
                }

                // check if it's trying to see a vendor that has permission to see
                if (user.vendors_template_access !== undefined && user.vendors_template_access.length) {
                    let cvendor = user.vendors_template_access.filter((vendor) => {
                        return url.includes(vendor.slug)
                    })
                    if (cvendor.length) return cvendor[0].id
                }

                return currentVendor.id
            }
        }
        return null
    }
}



// WEBPACK FOOTER //
// ./src/components/common/helpers.js